import confetti from "canvas-confetti";

// Brand palette (amber/orange/violet/gold) — used across all celebratory moments
// so confetti always feels "on brand" rather than generic rainbow default.
const BRAND_COLORS = ["#3B82F6", "#8B5CF6", "#6366F1", "#FBBF24"];

export function fireConfetti() {
  confetti({
    particleCount: 90,
    spread: 70,
    origin: { y: 0.6 },
    colors: BRAND_COLORS,
    startVelocity: 40,
    ticks: 200,
  });
}

export function fireBigConfetti() {
  const end = Date.now() + 700;
  (function frame() {
    confetti({ particleCount: 4, angle: 60, spread: 60, origin: { x: 0 }, colors: BRAND_COLORS });
    confetti({ particleCount: 4, angle: 120, spread: 60, origin: { x: 1 }, colors: BRAND_COLORS });
    if (Date.now() < end) requestAnimationFrame(frame);
  })();
}
